import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EmmsDashboard from "./EmmsDashboard";
import LicenseDashboard from "./LicenseDashboard";
import DevicesIcon from "@mui/icons-material/Devices";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { setLogoutUser } from "../redux/slices/userSlice";
import { setLogout } from "../redux/slices/authSlice";
import MobileScreenShareIcon from "@mui/icons-material/MobileScreenShare";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import BrushIcon from "@mui/icons-material/Brush";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import LocationDashboard from "./LocationDashboard";
import MeetingSpaceDashboard from "./MeetingSpaceDashboard";
import CustomisationDashboard from "./CustomisationDashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import ScreenuserDashboard from "./ScreenuserDashboard";
import ChangePasswordScreen from "./helpers/ChangePassword/ChangePasswordScreen";
import CalendarDashboard from "./CalendarDashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HelpAndSupport from "./HelpAndSupport";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import truInkIcon from "../logos/truInk.png";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import image1 from "../logos/homescreen.png";
import image2 from "../logos/regretscreen.png";
import Avatar from "@mui/material/Avatar";
import "./NavigationBar.css";
import img from "../logos/elmlogo.png";
import { setLogoutCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { setLogoutLocation } from "../redux/slices/locationSlice";
import { setLogoutCustomisation } from "../redux/slices/customisationSlice";
import { setLogoutMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setLogoutScreenuser } from "../redux/slices/screenusersSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import Button from "@mui/material/Button";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState ,useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";

import DeviceDashboard from "./DeviceDashboard";
import APIKeysDashboard from "./APIKeysDashboard";
import { setLogoutApikey } from "../redux/slices/apikeySlice";
import ElhiDeviceLandingDashboard from "./ElhiDeviceLandingDashboard";
import StagedDeviceDashboard from "./StagedDeviceDashboard";
import { setLogoutDevice } from "../redux/slices/deviceSlice";
import { setLogoutStagedDevice } from "../redux/slices/stagedDeviceSlice";
import GlobalConfigurationDashboard from "./GlobalConfigurationsDashboard";
import { ReportingDashboard } from "./ReportingDashboard";
import PieChartIcon from "@mui/icons-material/PieChart";
import AnalyticsDashboard from "./AnalyticsDashboard";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { setLogoutReporting } from "../redux/slices/reportingSlice";
import ContentLibraryDashboard from "./contentAi/ContentLibraryDashboard";
import TemplatesDashboard from "./contentAi/TemplatesDashboard";
import PlaylistDashboard from "./contentAi/PlaylistDashboard";
import ScheduleDashboard from "./contentAi/ScheduleDashboard";
import LayoutDashboard from "./contentAi/LayoutDashboard";
import KioskTemplatesDashboard from "./contentAi/KioskTemplatesDashboard";
import KioskStudioDashboard from "./contentAi/KioskStudioDashboard";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import ImageIcon from "@mui/icons-material/Image";
import HtmlIcon from "@mui/icons-material/Html";
import SplitscreenIcon from "@mui/icons-material/Splitscreen";
import EventNoteIcon from "@mui/icons-material/EventNote";
import FourKPlusIcon from "@mui/icons-material/FourKPlus";
import TabletMacIcon from "@mui/icons-material/TabletMac";
import ResolutionDashboard from "./contentAi/ResolutionDashboard";
import { ContentAIHelper } from "./contentAi/Helpers/ContentAIHelper";
import { setEmmLogoutScreenuserIds } from "../redux/slices/emmScreenuserSlice";
import TruInk from "./TruInk/Screens/TruInk";
import InkStoreDashboard from "./TruInk/Screens/InkStoreDashboard";
import { Collapse } from "@mui/material";
import {
  setTruInkSelectedOption,
  setTruInkSelectedSiteOption,
  setTruInkStateFromSessionStorage,
} from "../redux/slices/truInk";
import TruInkSubDrawer from "./TruInk/Components/TruInkSubDrawer";
import { LayoutTemplate, Pointer, Store, ToolCase } from "lucide-react";
import { Construction, PanToolAlt } from "@mui/icons-material";
import { Storefront } from "@material-ui/icons";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { keyframes } from "@mui/system";

import { display  } from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { decideFavIcon } from "../utils/decideFavIcon";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Popover } from "@mui/material";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import GroupIcon from '@mui/icons-material/Group';
import { UsersDashboard } from "./UsersDashboard";
import { SiteDashboard } from "./SiteDashboard";
import { TenantDashboard } from "./TenantDashboard";
import StoreIcon from '@mui/icons-material/Store';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

export default function PermanentDrawerLeft({ setActiveComponent, license }) {
  const drawerWidth = 270;

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [truInk, setTruInk] = useState(false);
  const headers = useSelector((state) => state.header);
  const [emms, setEmms] = useState(false);
  const [device, setDevice] = useState(false);
  const [adminSettingsOpen,setAdminSettingsOpen]=useState(false)
  const [reportingAndAnalytics, setReportingAndAnalytics] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const email = user?.user?.email;
  const username = email?.substring(0, email?.indexOf("@"));
  const [contentAI, setContentAI] = useState(false);
  const [kiosk, setKiosk] = useState(false);
  const tabs = useSelector(
    (state) => state?.user?.user?.customProperties?.tabs || []
  );
  const isSuperAdmin = useSelector(
    (state) => state?.user?.user?.superadmin || false
  );

  const [prevTruInk, setPrevTruInk] = useState(false);
  const isMobile = useMediaQuery("(max-width:960px)", {
    noSsr: true,
  });
  const [open, setOpen] = useState(isMobile);
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileBoxOpen, setProfileBoxOpen] = useState(false)
  const drawerRef = useRef(null);

  useEffect(() => {
  if (!isMobile || !open) return;

  const handleClickOutside = (event) => {
    if (
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      setOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [open, isMobile]);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);


  useEffect(() => {
    decideFavIcon(truInk)
    const timer = setTimeout(() => {
      setPrevTruInk(truInk);
    }, animationDuration);
    return () => clearTimeout(timer);
  }, [truInk])


  useEffect(() => {
    const sessionStorageState = sessionStorage.getItem("currentState");
    if (sessionStorageState) {
      const parsedState = JSON.parse(sessionStorageState);
      setTruInk(true);
      dispatch(setTruInkSelectedOption("TruInk"));
      setActiveComponent(<TruInk />);
      dispatch(setTruInkStateFromSessionStorage(parsedState));
      sessionStorage.removeItem("currentState");
    }
  }, []);

  useEffect(() => {
    if (location.pathname === "/inkhub") {
      setTruInk(true);
      setEmms(false);
      setDevice(false);
      setContentAI(false);
      setActiveComponent(<InkStoreDashboard />);
    } else if (location.pathname === "/truink") {
      setTruInk(true);
      setEmms(false);
      setDevice(false);
      setContentAI(false);
      dispatch(setTruInkSelectedOption("TruInk"));
      setActiveComponent(<TruInk />);
    }
  }, []);
  const onClickEmms = () => {
    if (license === true) {
      setEmms(true);
      setDevice(false);
      setTruInk(false);
      setAdminSettingsOpen(false)
      setActiveComponent(<EmmsDashboard />);
      navigate("/");
    }
  };

  const handlesignout = () => {
    setAdminSettingsOpen(false)
    setEmms(false);
    setDevice(false);
    dispatch(setLogoutUser());
    dispatch(setLogout());
    dispatch(setLogoutCurrentEmms());
    dispatch(setLogoutLocation());
    dispatch(setLogoutCustomisation());
    dispatch(setLogoutMeetingSpaces());
    dispatch(setLogoutScreenuser());
    dispatch(setEmmsHeaders());
    dispatch(setLogoutApikey());
    dispatch(setLogoutDevice());
    dispatch(setLogoutStagedDevice());
    dispatch(setEmmLogoutScreenuserIds());
    dispatch(setLogoutReporting());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
  };

  function TempDropDown({setOpen}) {
    const userRoles = user?.user?.customProperties || {};
    const isAdmin = userRoles?.admin == "true" || userRoles?.admin == true;
    const canAccessContentAI = userRoles.maker || userRoles.checker || isAdmin;

    return (
      <List style={{ marginLeft: "10%" }}>
        {canAccessContentAI && (
          <ListItem
            button
            onClick={() => {
              setContentAI(true);
            }}
          >
            {contentAI && <ContentAIHelper />}
            <ListItemIcon>
              <AddPhotoAlternateIcon />
            </ListItemIcon>
            <ListItemText primary="ContentAI" />
          </ListItem>
        )}
        {contentAI && ContentAIOPtions({setOpen})}

        {isAdmin && (
          <>
            <ListItem
              button
              onClick={() => {
                setActiveComponent(<LocationDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <LocationOnOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Locations" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setActiveComponent(<MeetingSpaceDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <MeetingRoomOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="MeetingSpaces" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setActiveComponent(<CustomisationDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <BrushIcon />
              </ListItemIcon>
              <ListItemText primary="Customizations" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setActiveComponent(<ScreenuserDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <MobileScreenShareIcon />
              </ListItemIcon>
              <ListItemText primary="ScreenUsers" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setActiveComponent(<CalendarDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <CalendarMonthIcon />
              </ListItemIcon>
              <ListItemText primary="Calendar Integration" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setActiveComponent(<GlobalConfigurationDashboard />);
                setContentAI(false);
                setOpen(false)
              }}
            >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Global Configurations" />
            </ListItem>

            <ListItem
              button
              onClick={() => {
                setContentAI(false);
                setReportingAndAnalytics(true);
              }}
            >
              <ListItemIcon>
                <PieChartIcon />
              </ListItemIcon>
              <ListItemText primary="Reporting & Analytics" />
            </ListItem>
            {reportingAndAnalytics ? AnayticsTempDropDown({ setOpen }) : null}
          </>
        )}

      </List>
    );
  }

  function AnayticsTempDropDown({ setOpen }) {
    return (
      <List style={{ marginLeft: "10%" }}>
        <ListItem
          button
          onClick={() => {
            setActiveComponent(<ReportingDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <PendingActionsIcon />
          </ListItemIcon>
          <ListItemText primary="Reporting" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<AnalyticsDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <PsychologyIcon />
          </ListItemIcon>
          <ListItemText primary="Analytics" />
        </ListItem>
      </List>
    );
  }

  function ContentAIOPtions({setOpen}) {
    return (
      <List style={{ marginLeft: "10%" }}>
        <ListItem
          button
          onClick={() => {
            setActiveComponent(<ResolutionDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <FourKPlusIcon />
          </ListItemIcon>
          <ListItemText primary="Resolutions" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            setActiveComponent(<ContentLibraryDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <ImageIcon />
          </ListItemIcon>
          <ListItemText primary="Content Library" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<TemplatesDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <HtmlIcon />
          </ListItemIcon>
          <ListItemText primary="Templates" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<PlaylistDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <PlaylistPlayIcon />
          </ListItemIcon>
          <ListItemText primary="Playlists" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<LayoutDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <SplitscreenIcon />
          </ListItemIcon>
          <ListItemText primary="Layouts" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<ScheduleDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <EventNoteIcon />
          </ListItemIcon>
          <ListItemText primary="Schedule/Events" />
        </ListItem>

        <ListItem
          button
          onClick={() => setKiosk((prev) => !prev)}
        >
          <ListItemIcon>
            <PanToolAlt />
          </ListItemIcon>
          <ListItemText primary="Kiosk" />
        </ListItem>
        {kiosk && (
          <List style={{ marginLeft: "10%" }}>
            {/* <ListItem
              button
              onClick={() => setActiveComponent(<KioskTemplatesDashboard />)}
            >
              <ListItemIcon>
                <Storefront  />
              </ListItemIcon>
              <ListItemText primary="Store" />
            </ListItem> */}
            <ListItem
              button
              onClick={() => setActiveComponent(<KioskStudioDashboard />)}
            >
              <ListItemIcon>
                <Construction />
              </ListItemIcon>
              <ListItemText primary="Kiosk Studio" />
            </ListItem>
          </List>
        )}
      </List>
    );
  }

  function DevicesTempDropDown({setOpen}) {
    return (
      <List style={{ marginLeft: "10%" }}>
        <ListItem
          button
          onClick={() => {
            setActiveComponent(<StagedDeviceDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <DisplaySettingsIcon />
          </ListItemIcon>
          <ListItemText primary=" Staged Devices" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            setActiveComponent(<DeviceDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <DevicesOtherIcon />
          </ListItemIcon>
          <ListItemText primary="Devices" />
        </ListItem>
      </List>
    );
  }

  function AdminSettingsOptions({setOpen,tabs}) {
    return (
      <List style={{ marginLeft: "10%" }}>

       { tabs.includes("tenant") && <ListItem
          button
          onClick={() => {
            setActiveComponent(<TenantDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <BusinessCenterIcon />
          </ListItemIcon>
          <ListItemText primary="Tenant" />
        </ListItem>

       }
        { tabs.includes("site") &&  <ListItem
          button
          onClick={() => {
            setActiveComponent(<SiteDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <StoreIcon />
          </ListItemIcon>
          <ListItemText primary="Site" />
        </ListItem>
        }

        { tabs.includes("users") && <ListItem
          button
          onClick={() => {
            setActiveComponent(<UsersDashboard />);
            setOpen(false)
          }}
        >
          <ListItemIcon>
            <GroupIcon/>
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
        }
      </List>
    );
  }


  const inkSweepIn = keyframes`
  0%   { transform: scaleX(0); transform-origin: left; }
  100% { transform: scaleX(1); transform-origin: left; }
`;

  const inkSweepOut = keyframes`
  0%   { transform: scaleX(0); transform-origin: right; }
  100% { transform: scaleX(1); transform-origin: right; }
`;

  const animationDuration = 1600;

  return (
    <>
      <AppBar
        position="fixed"
        id="main-header"
        sx={(theme) => ({
          "--ink-duration": `${animationDuration}ms`,
          zIndex: theme.zIndex.drawer + 1,
          overflow: "hidden",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          backgroundImage: "none",
          boxShadow: "none",
          borderBottom: "none",

          backgroundColor: prevTruInk ? "rgb(87,27,46)" : "#19433E",

          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundColor: truInk ? "rgb(87,27,46)" : "#19433E",
            animation: truInk
              ? `${inkSweepIn} var(--ink-duration) cubic-bezier(0.22, 1, 0.36, 1) forwards`
              : `${inkSweepOut} var(--ink-duration) cubic-bezier(0.22, 1, 0.36, 1) forwards`,
            pointerEvents: "none",
            willChange: "transform",
            zIndex: 0,
          },

          "& > *": {
            position: "relative",
            zIndex: 1,
          },
        })}
      >
        <Toolbar sx={{height:"64px"}} >
          <Typography
            noWrap
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              minWidth: 0,
              fontSize: "0.92rem",
              lineHeight: 1.2,
              overflow: "visible"
            }}
            variant="h6"
          >

            <IconButton
              onClick={() => setOpen(!open)}
              sx={{
                color: "white",
                backgroundColor: "transparent",
                width: 42,
                height: 42,
                transition: "all 0.3s ease",
                display: {
                  xs: "flex",
                  md: "none"
                }
              }}
            >
              {open ? <ArrowBackIosIcon /> : <MenuIcon />}
            </IconButton>

            <img
              src={
                truInk
                  ? "https://storage.googleapis.com/content_ai_bucket_elhitech/content/truink-log-header.png"
                  : "https://storage.googleapis.com/content_ai_bucket_elhitech/content/elhi_logo_white%20(1).png"
              }
              alt="logo"
              style={{
                height: truInk ? "35px" : "27px",
                marginRight: "8px",
                flexShrink: 0,
                position: truInk ? "relative" : "static",
                bottom: "4px"
              }}
            />

            <Box
              sx={{
                height: "23px",
                width: "1px",
                backgroundColor: "#e9ecf0ff",
                flexShrink: 0,
                ml: "4px",
                mr: "5px",
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            />
            <Typography
              sx={{
                marginLeft: "5px",
                color: "#e9ecf0ff",
                fontWeight: 400,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.96rem",
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            >
              {truInk ? "Elhi Landscape Manager" : "Landscape Manager"}
            </Typography>
          </Typography>

          {!isMobile ?
            <>
              <Button
            disableRipple
            style={{
              fontSize: 12,
              textTransform: "capitalize",
              marginRight: "0.5%",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            className="Button"
            color="inherit"
          >
            <AccountCircleIcon style={{ fontSize: "30px", marginRight: 7 }} />
            Hey, {username}
          </Button>

          <Button
            style={{
              fontSize: 12,
              textTransform: "none",
              marginLeft: "1%",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            className="Button"
            color="inherit"
            onClick={handlesignout}
          >
            Logout
          </Button>
            </>
            :
            <>
              <>
                <IconButton
                  onClick={() => setProfileBoxOpen(true)}
                  sx={{ color: "white" }}
                >
                  <AccountCircleIcon style={{ fontSize: "30px" }} />
                </IconButton>

                <Popover
                  open={profileBoxOpen}
                  anchorReference="anchorPosition"
                  anchorPosition={{ top: 64, left: window.innerWidth }}
                  PaperProps={{
                    style: {
                      borderRadius: "6px",
                      minWidth: "220px",
                      background: "#fff",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                      overflow: "hidden",
                    },
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      p: 2,
                      borderBottom: truInk
                        ? "1px solid rgba(87,27,46,0.15)"
                        : "1px solid rgba(25,67,62,0.15)",
                    }}
                  >
                    <AccountCircleIcon
                      style={{
                        fontSize: 40,
                        color: truInk ? "rgb(87,27,46)" : "#19433E",
                      }}
                    />
                    <Box>
                      <Typography
                        style={{
                          fontWeight: 600,
                          color: truInk ? "rgb(87,27,46)" : "#19433E",
                        }}
                      >
                        {username}
                      </Typography>

                      <Typography
                        variant="caption"
                        style={{
                          color: truInk ? "rgba(87,27,46,0.7)" : "rgba(25,67,62,0.7)",
                        }}
                      >
                        My Account
                      </Typography>
                    </Box>
                  </Box>

              
                  <Box
                    onClick={handlesignout}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      p: 2,
                      cursor: "pointer",
                      transition: "0.2s",
                      "&:hover": {
                        backgroundColor: truInk
                          ? "rgba(87,27,46,0.08)"
                          : "rgba(25,67,62,0.08)",
                      },
                    }}
                  >
                    <ExitToAppIcon
                      style={{
                        color: truInk ? "rgb(87,27,46)" : "#19433E",
                      }}
                    />

                    <Typography
                      style={{
                        color: truInk ? "rgb(87,27,46)" : "#19433E",
                        fontWeight: 500,
                      }}
                    >
                      Logout
                    </Typography>
                  </Box>

                  <Box
                    onClick={() => setProfileBoxOpen(false)}
                    sx={{
                      position: "fixed",
                      inset: 0,
                      zIndex: -1,
                    }}
                  />
                </Popover>
              </>
            </>
          }
        </Toolbar>
      </AppBar >

      <Box
        sx={{
          display: "flex",

        }}
        ref={drawerRef}
      >

        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,

            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",

              transform: isMobile
                ? open
                  ? "translateX(0)"
                  : "translateX(-100%)"
                : "none",

              opacity: isMobile ? (open ? 1 : 0) : 1,

              transition: isMobile
                ? "transform 0.35s ease, opacity 0.35s ease"
                : "none",

              overflowX: "hidden",
            },
          }}

          variant="permanent"
          anchor="left"
        >
          <Toolbar />
          <List>
          
            {tabs.includes("emms") && (
              <ListItem
                button
                onClick={() => {
                  onClickEmms();
                }}
              >
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="truRooms™ EMMS" />
              </ListItem>
            )}
            {emms ? TempDropDown({setOpen}) : null}

            {tabs.includes("truink") && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    setEmms(false);
                    setDevice(false);
                    setContentAI(false);
                    setTruInk(true);
                    dispatch(setTruInkSelectedOption("TruInk"));
                    setActiveComponent(<TruInk />);
                    navigate("/truink");
                    setOpen(false);
                    setAdminSettingsOpen(false)
                  }}
                >
                  <ListItemIcon>
                    <img
                      src={truInkIcon}
                      style={{ height: "30%", width: "50%" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="TruInk" />
                </ListItem>
                <Collapse in={truInk} timeout="auto" unmountOnExit>

                  <List component="div" disablePadding>
                    <ListItem
                      button
                      sx={{ pl: 4 }}
                      onClick={() => {
                        setActiveComponent(<InkStoreDashboard />);
                        navigate("/inkhub");
                      }}
                    >
                      <ListItemIcon>
                        <ShoppingCartIcon sx={{ fontSize: 20 }} />
                      </ListItemIcon>
                      <ListItemText primary="inkHub" primaryTypographyProps={{ fontSize: "0.9rem" }} />
                    </ListItem>
                  </List>

                </Collapse>
              </>
            )}

           
            {tabs.includes("device") && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    setEmms(false);
                    setDevice(true);
                    setContentAI(false);
                    setTruInk(false);
                    setActiveComponent(<ElhiDeviceLandingDashboard />);
                    navigate("/");
                    setOpen(false);
                    setAdminSettingsOpen(false)
                  }}
                >
                  <ListItemIcon>
                    <DevicesIcon />
                  </ListItemIcon>
                  <ListItemText primary="Elhi Devices" />
                </ListItem>
                {device ? DevicesTempDropDown({ setOpen }) : null}
              </>
            )}

          
            {tabs.includes("apikeys") && (
              <ListItem
                button
                onClick={() => {
                  setEmms(false);
                  setDevice(false);
                  setContentAI(false);
                  setTruInk(false);
                  setActiveComponent(<APIKeysDashboard />);
                  navigate("/");

                  setOpen(false);
                  setAdminSettingsOpen(false)
                }}
              >
                <ListItemIcon>
                  <VpnKeyIcon />
                </ListItemIcon>
                <ListItemText primary="Keys & Secrets" />
              </ListItem>
            )}

         
            {tabs.includes("license") && (
              <ListItem
                button
                onClick={() => {
                  setEmms(false);
                  setDevice(false);
                  setContentAI(false);
                  setTruInk(false);
                  setActiveComponent(<LicenseDashboard />);
                  navigate("/");
                  setOpen(false);
                  setAdminSettingsOpen(false)
                }}
              >
                <ListItemIcon>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemText primary="Licenses" />
              </ListItem>
            )}
            {tabs.includes("support") && (
              <ListItem
                button
                onClick={() => {
                  setEmms(false);
                  setDevice(false);
                  setContentAI(false);
                  setTruInk(false);
                  setActiveComponent(<HelpAndSupport />);
                  navigate("/");
                  setOpen(false);
                  setAdminSettingsOpen(false)
                }}
              >
                <ListItemIcon>
                  <SupportAgentIcon />
                </ListItemIcon>
                <ListItemText primary="Help & Support" />
              </ListItem>
            )}
            {tabs.includes("changepassword") && (
              <ListItem
                button
                onClick={() => {
                  setEmms(false);
                  setDevice(false);
                  setContentAI(false);
                  setTruInk(false);
                  setActiveComponent(<ChangePasswordScreen />);
                  navigate("/");
                  setOpen(false);
                  setAdminSettingsOpen(false)
                }}
              >
                <ListItemIcon>
                  <SettingsApplicationsIcon />
                </ListItemIcon>
                <ListItemText primary="Change Password" />
              </ListItem>
            )}

            {(tabs.includes("adminsettings") && isSuperAdmin) && (
              <ListItem
                button
                onClick={() => {
                  setAdminSettingsOpen(true)
                  setEmms(false);
                  setDevice(false);
                  setContentAI(false);
                  setTruInk(false);
                  navigate("/");
                }}
              >
                <ListItemIcon>
                  <AdminPanelSettingsIcon/>
                </ListItemIcon>
                <ListItemText primary="Admin Settings" />
              </ListItem>
            )}
            {(adminSettingsOpen && isSuperAdmin) ? AdminSettingsOptions({setOpen,tabs}) : null}
  
          </List>
        </Drawer>
      </Box>
    </>
  );
}
